import { Notice, Modal } from 'view-design';
import { query2Obj } from '../utils';
import router from '../router';
import store from '../store/index';
import sessionStorage from '../utils/storage/sessionStorage';

export function handleAction(data = {}) {
  const { action, url, title, message } = data;
  if (action === 'toast') {
    message && showToast({ title, message });
  } else if (action === 'jump') {
    url && jump(url);
  }
}

export function showToast(
  { title = '温馨提示', message, duration },
  type = 'info'
) {
  Notice[type]({
    title,
    desc: message,
    duration: duration || 3
  });
}

export function jump(path, blank = false) {
  if (/^https?.+/.test(path)) {
    if (blank) {
      window.open(path, '_blank');
    } else {
      window.location.href = path;
    }
    return;
  }
  const query = query2Obj(path);
  const redirect = query.__r == 1;
  if (redirect) {
    router.replace({
      path
    });
  } else {
    router.push({
      path
    });
  }
}
export function jump2(path) {
  window.location.href = path;
}

export function showConfirm(modal = {}) {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      ...modal,
      onOk: resolve,
      onCancel: reject
    });
  });
}

/**
 * 只读提示弹窗：只有一个「确定」（对齐 h5 的 showConfirm({ showCancel: false })）。
 * 用于请求层提示较长的错误文案（短文案走 showToast 即可）
 */
export function showAlert(content, title = '温馨提示') {
  return new Promise(resolve => {
    Modal.info({
      title,
      content,
      onOk: resolve
    });
  });
}

/**
 *
 * @param {any} message
 * @param {string} level ['log', 'info', 'warn', 'error']
 */
export function logger(message, level = 'log') {
  /* eslint-disable */
  if (console[level] && typeof console[level] === 'function') {
    console[level](message);
  }
  /* eslint-enable */
}

export function setTitle(title) {
  if (!title || typeof title !== 'string') return;
  document.title = title;
}
export function setIcon(img) {
  if (!img || typeof img !== 'string') return;
  const link = document.createElement('link');
  link.setAttribute('rel', 'icon');
  link.setAttribute('href', img);
  document.head.appendChild(link);
}

/*
 * changeURLStatic 修改地址栏URL参数
 *   @param name 参数名
 *   @param value 参数值
 * */
export function changeURLStatic(name, value) {
  const href = location.href;
  const reg = eval('/([?|&]' + name + '=)[^&]*/gi');
  value = value.toString().replace(/(^\s*)|(\s*$)/g, '');
  let url = '';
  if (!value) {
    url = href.replace(reg, ''); //正则替换
  } else {
    if (href.match(reg)) {
      url = href.replace(reg, '$1' + value);
    } else {
      url = href + (href.indexOf('?') > -1 ? '&' : '?') + name + '=' + value;
    }
  }
  history.replaceState(null, null, url);
}

/**
 * 保存专场ID
 * @param {string} channelId
 */
export function saveChannelId(channelId) {
  if (!channelId) return;
  sessionStorage.set('channel_id', channelId);
  store.commit('common/setChannelId', channelId);
}

/**
 * 保存定制专场ID
 * @param {string} customId
 */
export function saveCustomId(customId) {
  if (!customId) return;
  sessionStorage.set('custom_id', customId);
  store.commit('common/setCustomId', customId);
}

// 获取路由参数
export function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

// 获取专场id ( 从路由参数与sessionStorage中 )
export function getChannelId() {
  let channel_id =
    getQueryVariable('channel_id') || sessionStorage.get('channel_id');
  return channel_id;
}
export function getCustomId() {
  let channel_id =
    getQueryVariable('custom_id') || sessionStorage.get('custom_id');
  return channel_id;
}

// custom_id 的空值口径：''、null、undefined、'undefined'、0、'0' 都算「没有定制 id」
// （0 也归到空里：后端把 custom_id=0 当作没传定制专场，而定制站的 id 都是正整数，
//   0 没有实际语义；URL 上的 ?custom_id=0 得到的是字符串 '0'，所以两种都要算）
function isEmptyCustomId(value) {
  return (
    value === undefined ||
    value === null ||
    value === '' ||
    value === 'undefined' ||
    value === 0 ||
    value === '0'
  );
}

/**
 * 请求公共参数 custom_id 的取值规则（lib/request 里各服务、requestFlatGet 共用）：
 *   1) 调用方显式传了有效 custom_id（非空且不为 0）就用调用方的
 *      —— 项目里有些地方传的是 data 的默认空值（如 cartV2 的 custom_id: null、
 *      cancelOrder({ custom_id: '' })），那是「还没确定」，不是「不要定制 id」，
 *      所以空值（含 0 / '0'）不参与判断，按下面第 3 条取当前定制 id
 *   2) 参数里带 hideAddCommonParam: true（声明本次不注入公共参数，如 /v1/ext_app/list）时不补
 *   3) 其余情况取当前定制 id（URL 上的 custom_id 优先，其次 sessionStorage）
 * 三种来源都为空（含 0）时整个字段都不发 —— 后端把 custom_id=0 当没传，
 * 但带上去会污染日志/校验（如 /v2/ctrip/scenic/index）
 * 注意 'undefined' 字符串视为未设置（历史数据里存过这个字符串）
 * @param {object} params 请求参数
 * @returns {string|number|undefined} 最终仍为空时返回 undefined（调用方据此不加这个字段）
 */
export function pickCustomId(params = {}) {
  const own = params.custom_id;
  if (!isEmptyCustomId(own)) return own;
  if (params.hideAddCommonParam) return undefined;
  const customId = getCustomId();
  return isEmptyCustomId(customId) ? undefined : customId;
}

/**
 * 把 custom_id 写进最终的请求参数：取不到就**整个字段都不带**
 * （后端收到空串会判「请求参数错误」，不能发 ''）
 * @param {object} target 最终请求参数（会被改写）
 * @param {object} params 原始入参（用于判断调用方是否显式指定、是否声明不注入）
 * @returns {object} target
 */
export function injectCustomId(target, params) {
  const customId = pickCustomId(params);
  if (customId === undefined) {
    delete target.custom_id;
  } else {
    target.custom_id = customId;
  }
  return target;
}
